module.exports = __webpack_public_path__ + "static/media/dod.48429fbbb9a3390fbf2439ef7af63de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dod.png
// module id = 2505
// module chunks = 1